import { ProcessingLenderStrategyType, ProcessingMode, StopCondition } from '@nemuru-eng/js-api-client';
import { ChooseStrategyType } from '@nemuru-eng/js-api-client/slim';

import { AutomaticModeDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/AutomaticModeDiagram';
import { ManualModeDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/ManualModeDiagram';
import { ParallelDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/ParallelDiagram';
import { RankingBorrowerSelectionDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingBorrowerSelectionDiagram';
import { RankingIberiaDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingIberiaDiagram';
import { RankingMaxProfitabilityDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingMaxProfitabilityDiagram';
import { RankingMinAprDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingMinAprDiagram';
import { RankingPriorityLenderDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingPriorityLenderDiagram';
import { RankingShareOfWalletDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/RankingShareOfWalletDiagram';
import { StopConditionDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/StopConditionDiagram';
import { WaterfallDiagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/WaterfallDiagram';
import { OrchestrationField } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/OrchestrationField';

interface OrchestrationOptionDiagramProps {
  field: OrchestrationField;
  value: string;
}

const RANKING_DIAGRAMS: Partial<Record<string, () => JSX.Element>> = {
  [ChooseStrategyType.MIN_APR]: RankingMinAprDiagram,
  [ChooseStrategyType.MAX_PROFITABILITY]: RankingMaxProfitabilityDiagram,
  [ChooseStrategyType.SHARE_OF_WALLET]: RankingShareOfWalletDiagram,
  [ChooseStrategyType.PRIORITY_LENDER_THEN_PRICE]: RankingPriorityLenderDiagram,
  [ChooseStrategyType.BORROWER_SELECTION]: RankingBorrowerSelectionDiagram,
  [ChooseStrategyType.IBERIA]: RankingIberiaDiagram,
};

export const OrchestrationOptionDiagram = ({ field, value }: OrchestrationOptionDiagramProps) => {
  if (field === OrchestrationField.STRATEGY) {
    return value === ProcessingLenderStrategyType.PARALLEL ? <ParallelDiagram /> : <WaterfallDiagram />;
  }
  if (field === OrchestrationField.MODE) {
    return value === ProcessingMode.MANUAL ? <ManualModeDiagram /> : <AutomaticModeDiagram />;
  }
  if (field === OrchestrationField.STOP) {
    return <StopConditionDiagram stopCondition={value as StopCondition} />;
  }

  const RankingDiagram = RANKING_DIAGRAMS[value];

  return RankingDiagram ? <RankingDiagram /> : null;
};
